import { useApps } from '@auth/useApps'
import { colors } from '@globals/themes/defaultTheme'
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded'
import Button from '@mui/material/Button'
import { SxProps } from '@mui/material/styles'
import { AppPermission } from '@shared/permissions'
import useRecognitionModal, {
  RecognitionModalViews,
} from '@tenant/recognition/RecognitionModal/useRecognitionModal'

import { T } from '@transifex/react'

const buttonStyle: SxProps = {
  height: '100%',
  whiteSpace: 'normal',
  textAlign: 'justify',
  mt: 2,
}

const iconStyle: SxProps = {
  width: '2rem',
  height: '2rem',
  color: `${colors.goldPrimary} !important`,
}

const RecognizeSomeoneBtn: React.FC = () => {
  const { openDialog } = useRecognitionModal()
  const [hasPermission] = useApps()
  const showRecognizeButton =
    hasPermission('recognitionApp', AppPermission.RecognitionAppBrowse) ||
    hasPermission('recognitionApp', AppPermission.RecognitionAppUpgradeLicense)

  return (
    showRecognizeButton && (
      <Button
        id="btnRecognizeSomeone"
        variant="outlined"
        size="large"
        sx={buttonStyle}
        startIcon={<StarBorderRoundedIcon fontSize="inherit" sx={iconStyle} />}
        onClick={() => {
          openDialog({
            view: RecognitionModalViews.SendRecognition,
          })
        }}>
        <T _str="Recognize someone" />
      </Button>
    )
  )
}

export default RecognizeSomeoneBtn
